export const DAYS = ["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"];

const OLD_KEYS = {
  cerveja: "Cervejas", destilado: "Destilados", vinho: "Vinhos", drink: "Outros", refrigerante: "Refrigerantes e sucos",
  energetico: "Refrigerantes e sucos", gelo: "Gelo e carvão", petisco: "Petiscos", tabacaria: "Outros", outro: "Outros",
};
export const categoryLabel = (k) => OLD_KEYS[k] || k;

export function defaultHours() {
  const h = {};
  for (let d = 0; d < 7; d++) h[String(d)] = { open: true, start: "10:00", end: d >= 4 ? "02:00" : "23:00" };
  return h;
}

export const brl = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export function waLink(digits, text) {
  const d = String(digits || "").replace(/\D/g, "");
  const full = d.startsWith("55") && d.length >= 12 ? d : `55${d}`;
  return `https://wa.me/${full}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
}

export const mapsLink = (lat, lng) => `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

export const todayIndex = () => (new Date().getDay() + 6) % 7;

export const hoursLabel = (h) => (h?.open ? `${h.start} – ${h.end}` : "Fechado");

export const fmtDate = (iso) => (iso ? new Date(iso.length === 10 ? `${iso}T00:00:00` : iso).toLocaleDateString("pt-BR") : "");

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false }) : "";

export const parsePrice = (s) => (s === "" || s == null ? null : Number(String(s).replace(",", ".")));
export const priceInput = (v) => (v == null ? "" : String(v).replace(".", ","));
